import { FormattedFile } from "@/react/components/entityViews/files/context/EntityFileContext";

export interface SpotIncentiveFileData {
  document_id?: number;
  image?: File;
  imageUrl?: string;
  comment: string;
}

/**
 * Converts a blob URL to a File object
 */
async function blobUrlToFile(blobUrl: string, filename: string): Promise<File> {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
}

/**
 * Prepares file data for the SpotIncentive editor
 * - For BoardFile: uses documentId
 * - For CompanyCam images: fetches blob and converts to File
 */
export async function prepareFileForSpotIncentive(
  file: FormattedFile
): Promise<SpotIncentiveFileData | null> {
  try {
    // If it's a BoardFile with documentId, use that
    if (file.record && file.record.documentId) {
      return {
        document_id: file.record.documentId,
        imageUrl: file.record.url || file.originalImageUrl,
        comment: file.description || ""
      };
    }

    // If it's a CompanyCam image with originalImageUrl, convert blob to File
    if (file.isCCImage && file.originalImageUrl) {
      const imageFile = await blobUrlToFile(file.originalImageUrl, file.name);
      return {
        image: imageFile,
        imageUrl: file.originalImageUrl,
        comment: file.description || ""
      };
    }

    return null;
  } catch (error) {
    console.error("Error preparing file for spot incentive:", error);
    return null;
  }
}
